// @flow
import React, { Component } from 'react';
import ConfirmationModal from './ConfirmationModal';
import SuccessModal from './SuccessModal';
import * as modalTypes from './modalTypes';
import { type ConfirmationModalPayload } from './ConfirmationModal';
import ErrorModal from './ErrorModal';

type ConfirmationModalProps = {
  modal: typeof modalTypes.CONFIRMATION_MODAL,
  payload: ConfirmationModalPayload,
  closeModal: () => void
};
type ErrorModalProps = {
  modal: typeof modalTypes.ERROR_MODAL,
  closeModal: () => void,
  payload: { message: string, title: string }
};
type SuccessModalProps = {
  modal: typeof modalTypes.SUCCESS_MODAL,
  closeModal: () => void,
  payload: { message: string }
};
type Props = ConfirmationModalProps | ErrorModalProps | SuccessModalProps;

export default class Conductor extends Component<Props> {
  render() {
    const { props } = this;
    switch (props.modal) {
      case modalTypes.CONFIRMATION_MODAL:
        return (
          // $FlowFixMe
          <ConfirmationModal {...props.payload} closeModal={props.closeModal} />
        );
      case modalTypes.SUCCESS_MODAL:
        return (
          // $FlowFixMe
          <SuccessModal {...props.payload} closeModal={props.closeModal} />
        );
      case modalTypes.ERROR_MODAL:
        return <ErrorModal {...props.payload} closeModal={props.closeModal} />;
      default:
        return null;
    }
  }
}
